export default __webpack_public_path__ + "static/media/box1_bak3.2d506e99.png";